import { render } from "./designAddressPreview.vue?vue&type=template&id=7165cdf4"
import script from "./designAddressPreview.vue?vue&type=script&lang=js"
export * from "./designAddressPreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__